"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.76,0H2.24a.56.56,0,0,0-.63.64V20.15a.56.56,0,0,0,.63.64H8.63l3.21,3.15a.24.24,0,0,0,.32,0l3.21-3.15h6.39a.56.56,0,0,0,.63-.64V.64A.56.56,0,0,0,21.76,0Z",
    style: {
      fill: '#004864'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.56,6.91c-.09.1-.05.33-.05.33v8.91H9.41V7.24s0-.24-.1-.33A.57.57,0,0,0,9,6.84H3.7V3.94H20.3v2.9H14.94s-.29,0-.38.07",
    style: {
      fill: '#fff'
    }
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "8.03 13.25 8.03 16.16 3.7 16.16 3.7 7.43 8.03 7.43 8.03 10.33 9.06 10.32 9.06 13.25 8.03 13.25",
    style: {
      fill: '#fff'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.87,10.31h.34a.8.8,0,0,0,.56-.15A1.18,1.18,0,0,0,16,9.34V7.45H20.2s.22,2.43-.74,3.39-3.47.73-3.47.73V12s2.5-.25,3.47.74.74,3.38.74,3.38H16V14.27a1.29,1.29,0,0,0-.22-.81.63.63,0,0,0-.6-.21h-.3Z",
    style: {
      fill: '#fff'
    }
  }));
};

exports["default"] = _default;